<!--
 * @Descripttion: 商品详情
 * @FilePath: /mall-wap-vue/src/views/product/detail/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 22:17:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-05 01:55:35
-->
<template>
  <div>
    <div
      :class="{
        detail_con_out: false,
        detail_con_none: mallretailspu === null,
      }"
      class="detail_con"
    >
      <!-- 初始化头部头部 -->
      <div class="title_bar">
        <div
          :style="opacityStyleShow"
          v-if="opacityStyleShow.opacity === 1"
          class="top_share"
        >
          <div class="clearfix">
            <img
              src="@/assets/product/icon_back_default_dark@2x.png"
              alt=""
              class="left mr_l"
              @click="goBack"
            />
            <!-- <img
            src="@/assets/product/icon_favorite_nor_24@2x.png"
            alt=""
            class="right"
          /> -->
            <img
              v-if="mallretailspu !== null"
              src="@/assets/product/icon_share@2x.png"
              alt=""
              class="right"
              @click="clickShowPoster"
            />
          </div>
        </div>
        <!-- 下拉头部 -->
        <div :style="opacityStyle" v-if="opacityStyle.opacity > 0" class="bar">
          <div class="search_bar">
            <img
              src="@/assets/common/icon_back@2x.png"
              alt=""
              class="go_back left"
              @click="goBack"
            />
            <img
              v-if="mallretailspu !== null"
              src="@/assets/product/icon_share_black@2x (1).png"
              alt=""
              class="share mr_l right"
              @click="clickShowPoster"
            />
            <!-- <img
            src="@/assets/product/icon_share_black@2x (2).png"
            alt=""
            class="share right"
          /> -->
            <div class="bar_title font14 font_weight500 colo050">
              <div
                v-for="(item, index) in titleBarList"
                :key="index"
                class="title_item mr_r"
              >
                <!-- <a :href="item.herf" class="title_item mr_r"> -->
                <div :class="{ colo0: clickTitleIndex === index }">
                  {{ item.title }}
                </div>
                <div v-if="clickTitleIndex === index" class="line"></div>
                <!-- </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <div v-if="mallretailspu !== null">
        <div class="swiper_list">
          <swiper :pictures="pictures" :chooseSkuIndex="chooseSkuIndex" />
        </div>
        <div ref="product" id="product" class="other_con">
          <!-- spu   sku 选择器-->
          <div class="spu_sku">
            <spu-sku-list @switchSpuSku="switchSpuSku" @switchSpu="switchSpu" />
          </div>
          <!-- spu 选择器-->
          <div
            v-if="
              mallretailspu.relationSpus &&
                mallretailspu.relationSpus !== null &&
                mallretailspu.relationSpus.length > 1
            "
            class="sku"
          >
            <sku-list @switchSku="switchSku" />
          </div>
          <!--  名称 -->
          <spu-name />
          <!-- 活动满赠 -->
          <active-info
            v-if="mallretailspu.gift && mallretailspu.gift !== null"
            @showActive="showActive"
          />
          <!-- 活动满赠弹窗 -->
          <active-action-sheet
            v-if="showActiveSheet"
            :checkGiftList="checkGiftList"
            @closeSheet="closeSheet"
            @goGiftSelect="goGiftSelect"
            @goDetail="goDetail"
          />
          <active-sku-select
            v-if="showActiveSkuSelect"
            :gitCheckIndex="gitCheckIndex"
            @closeSheet="closeActiveSheet"
            @sureGift="sureGift"
          />
          <!-- 发货流程 -->
          <step />
          <div class="middle_info">
            <!-- sku颜色选择 -->
            <sku-color :selectSkuString="selectSkuString" @showSku="showSku" />
            <!-- 选择弹窗 -->
            <sku-action-sheet
              v-if="showSkuSheet"
              :bottomBtnSwitch="bottomBtnSwitch"
              :initialSku="initialSku"
              @closeSheet="closeSheet"
              @stepperChange="stepperChange"
              @goNow="goNow"
              @addCart="addCart"
              @closeSelectSku="closeSelectSku"
              @sureSelectSku="sureSelectSku"
            />
            <!-- 地址模块 -->
            <delivery-address v-if="false" @showAddress="showAddress" />
            <address-list-action-sheet
              v-if="showAddressSheet"
              @closeSheet="closeSheet"
              @clickListItem="clickListItem"
            />
            <!-- 运费模块 -->
            <freight @showFright="showFright" />
            <!-- 运费说明 -->
            <freight-action-sheet
              v-if="showFrightSheet"
              @closeSheet="closeSheet"
            />
            <!-- 七天无理由 -->
          <perspective v-if="showPerspective" />

            <!-- 无理由退货模块 -->
            <!-- <refund-reasion @showReasion="showReasion" /> -->
            <!-- 退货说明 -->
            <!-- <refund-reasion-action-sheet
              v-if="showReasionSheet"
              @closeSheet="closeSheet"
            /> -->
          </div>

          <div
            class="middle_info"
            style="margin-top: 12px;border-radius: 6px;"
            @click="onBuyerReviewsClick"
          >
            <!-- 买家评论 -->
            <buyer-reviews />
          </div>

          

          <!-- 店铺模块 -->
          <shop-info
            v-if="mallretailspu.brand && mallretailspu.brand !== null"
            @goBrand="goBrand"
          />
          <!-- 商品详情模块 -->
          <div ref="details">
            <details-info v-if="mallretailspu.description" id="details" />
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="bottom_fixed">
          <bottom-btn @changeShowItem="changeShowItem" @clickBtn="clickBtn" />
        </div>
      </div>
      <div
        v-if="mallretailspu === null"
        class="none_detail font14 font_weight400 line_height_20"
      >
        <img src="@/assets/common/none_icon@2x.png" alt="" />
        该商品飞走了
      </div>
      <!-- 切换推荐 -->
      <!-- <recom-switch ref="recomment" id="recomment" @switchCase="switchCase" /> -->
      <!-- 黑色背景 -->
      <div v-if="showBg" class="bg"></div>
      <!-- 海报 -->
      <poster
        v-if="showPoster"
        :show="showPoster"
        :posterItem="mallretailspu"
        @closePoster="closePoster"
        @openShare="openShare"
      />
      <share-mask v-if="showShareMask" @hideMask="hideMask" />
      <!-- 地址选择器 -->
      <div class="font0">
        <address-select-sheet
          v-if="showAddressSelectSheet"
          @closeSheet="closeSheet"
          @getSelectAddress="getSelectAddress"
        />
      </div>
    </div>
  </div>
</template>
<script>
import NativeShare from "nativeshare";
// import PinganAddressSelect from "@/utils/address";
import Swiper from "./components/Swiper";
import SpuSkuList from "./components/SpuSkuList";
import SkuList from "./components/SkuList";
import SpuName from "./components/SpuName";
import ActiveInfo from "./components/ActiveInfo";
const ActiveActionSheet = () =>
  import("./components/ActiveActionSheet").then((m) => m.default || m);
const ActiveSkuSelect = () =>
  import("./components/ActiveSkuSelect").then((m) => m.default || m);
import Step from "./components/Step";
import SkuColor from "./components/SkuColor";
import DeliveryAddress from "./components/DeliveryAddress";
const AddressListActionSheet = () =>
  import("./components/AddressListActionSheet").then((m) => m.default || m);
import Freight from "./components/Freight";
const FreightActionSheet = () =>
  import("./components/FreightActionSheet").then((m) => m.default || m);
const BuyerReviews = () =>
  import("./components/BuyerReviews").then((m) => m.default || m);
const Perspective = () =>
  import("./components/Perspective").then((m) => m.default || m);
// import RefundReasion from "./components/RefundReasion";
// const RefundReasionActionSheet = () =>
//   import("./components/RefundReasionActionSheet").then(m => m.default || m);
const ShopInfo = () =>
  import("./components/ShopInfo").then((m) => m.default || m);
const DetailsInfo = () =>
  import("./components/DetailsInfo").then((m) => m.default || m);
// const RecomSwitch = () =>
//   import("./components/RecomSwitch").then(m => m.default || m);
const BottomBtn = () =>
  import("./components/BottomBtn").then((m) => m.default || m);
const Poster = () => import("./components/Poster").then((m) => m.default || m);
const AddressSelectSheet = () =>
  import("./components/AddressSelectSheet").then((m) => m.default || m);
const SkuActionSheet = () =>
  import("./components/SkuActionSheet").then((m) => m.default || m);
const ShareMask = () =>
  import("../../mine/cardvoucher/components/ShareMask").then(
    (m) => m.default || m
  );
export default {
  components: {
    Swiper,
    SpuSkuList,
    SkuList,
    SpuName,
    ActiveInfo,
    ActiveActionSheet,
    ActiveSkuSelect,
    Step,
    SkuColor,
    DeliveryAddress,
    AddressListActionSheet,
    Freight,
    FreightActionSheet,
    BuyerReviews,
    Perspective,
    // RefundReasionActionSheet,
    // RefundReasion,
    ShopInfo,
    DetailsInfo,
    // RecomSwitch,
    BottomBtn,
    Poster,
    AddressSelectSheet,
    SkuActionSheet,
    ShareMask,
  },
  data() {
    return {
      skuIndex: 1,
      showBg: false,
      showFrightSheet: false,
      showReasionSheet: false,
      showAddressSheet: false,
      showActiveSheet: false,
      showActiveSkuSelect: false,
      showAddressSelectSheet: false,
      showSkuSheet: false,
      titleBarList: [
        { title: "商品", herf: "#product" },
        { title: "详情", herf: "#details" },
        // { title: "推荐", herf: "#recomment" }
      ],
      clickTitleIndex: 0,
      opacityStyle: {
        opacity: 0,
      },
      opacityStyleShow: {
        opacity: 1,
      },
      showPoster: false,
      bottomBtnSwitch: "skuSelect",
      skuNum: 1,
      gitCheckIndex: 0,
      checkGiftList: [],
      giftSpuId: "",
      pictures: [],
      chooseSkuIndex: 0,
      selectSkuString: "",
      posterItem: {},
      showShareMask: false,
      initialSku: {},
    };
  },
  computed: {
    mallretailspu() {
      if (this.$store.getters.mallretailspu === null) {
        return null;
      } else {
        const { skus } = this.$store.getters.mallretailspu;
        for (let sku in skus) {
          if (skus[sku].id == this.$route.query.skuId) {
            // console.log(sku);
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.selectSkuString = sku.split(">")[0] + " " + sku.split(">")[1];
          }
        }
        return this.$store.getters.mallretailspu;
      }
    },
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    },
    showPerspective() {
      return this.mallretailspu.perspectiveView;
    },
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      this.getData(this.$route.query.id);
      this.showActiveSheet = false;
    },
  },
  created() {
    this.getData(this.$route.query.id);
    this.getUserData();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 详情数据
    getData(spuId) {
      // getCartList
      const params = {
        spuId,
        slug: this.slug,
      };
      this.$store
        .dispatch("product/mallretailspu", { params })
        .then(() => {
          this.pictures = this.mallretailspu.pictures;
          const { skus } = this.mallretailspu;
          const { skuProps } = this.$store.getters.mallretailspu;
          for (let sku in skus) {
            if (skus[sku].id == this.$route.query.skuId) {
              skuProps.forEach((item, index) => {
                this.initialSku[item.prop] = sku.split(">")[index];
              });
              this.initialSku.selectedNum = 1;
            }
          }
          // this.initialSku = {};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 海报获取用户数据
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    //tabBar透明度
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let productTo = this.$refs.product.offsetTop + 50;
      // let detailsTo = this.$refs.details.offsetTop;
      if (top <= productTo) {
        this.clickTitleIndex = 0;
      }
      if (top > productTo) {
        this.clickTitleIndex = 1;
      }
      let opacity = top / 60;
      opacity = opacity > 1 ? 1 : opacity;
      let opacity1 = 1 - opacity;
      this.opacityStyle = { opacity };
      this.opacityStyleShow = {
        opacity: opacity1,
      };
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // 上部spu切换
    switchSku(index, spuId) {
      // this.skuIndex = index;
      this.getData(spuId);
    },
    // 上部spu, sku切换
    switchSpuSku(index) {
      // this.skuIndex = index;
      // this.pictures = this.mallretailspu.pictures;
      let imgs = [];
      this.mallretailspu.skuUrl.map((item) => {
        imgs.push({ masterImg: item.masterImg });
      });
      this.pictures = imgs;
      this.chooseSkuIndex = index;
      // console.log(index, "spuSkuList");
    },
    // 上部点击spu切换
    switchSpu() {
      this.pictures = JSON.parse(JSON.stringify(this.mallretailspu.pictures));
    },
    // 切换底部推荐
    // switchCase(index) {
    //   console.log("切换index" + index);
    // },
    // 跳转品牌馆
    goBrand() {
      this.$router.push({
        path: "/category/brand",
        query: {
          id: this.mallretailspu.brand.id,
        },
      });
    },
    // 缺货时的背景色
    changeShowItem(show) {
      this.showBg = show;
    },
    // 显示sku选择器
    showSku() {
      this.showSkuSheet = true;
      this.bottomBtnSwitch = "skuSelect";
    },
    // 显示运费
    showFright() {
      this.showFrightSheet = true;
    },
    // 显示活动
    showActive() {
      this.showActiveSheet = true;
    },
    // 显示无理由退换货
    showReasion() {
      this.showReasionSheet = true;
    },
    // 显示地址列表
    showAddress() {
      this.showAddressSheet = true;
    },
    // 显示地址选择器
    clickListItem() {
      this.showAddressSheet = false;
      this.showAddressSelectSheet = true;
    },
    // 获取选择地址
    // getSelectAddress(address) {
    //   console.log(address, "获取用户选择的地址");
    // },
    closePoster() {
      this.showPoster = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    openShare() {
      // console.log(typeof NativeShare);
      // console.log(NativeShare, 88888);
      if (typeof NativeShare !== "undefined") {
        // console.log(111);
        if (this.isWechatBrowser()) {
          // console.log(222);
          this.showPoster = false;
          this.showShareMask = true;
        } else {
          this.$toast("需要在微信浏览器分享哦！");
        }
      } else {
        this.showPoster = false;
      }
    },
    closeSheet() {
      this.showFrightSheet = false;
      this.showReasionSheet = false;
      this.showAddressSheet = false;
      this.showActiveSheet = false;
      this.showAddressSelectSheet = false;
      this.showSkuSheet = false;
      this.showActiveSkuSelect = false;
    },
    closeActiveSheet() {
      this.showFrightSheet = false;
      this.showReasionSheet = false;
      this.showAddressSheet = false;
      this.showAddressSelectSheet = false;
      this.showSkuSheet = false;
      this.showActiveSkuSelect = false;
    },
    // 显示赠品选择
    goGiftSelect(index, id) {
      // console.log(index);
      this.gitCheckIndex = index;
      this.giftSpuId = id;
      this.showActiveSkuSelect = true;
      // console.log(this.showActiveSkuSelect);
    },
    // 立即购买 buyNow addCart
    clickBtn(value) {
      this.showSkuSheet = true;
      this.bottomBtnSwitch = value;
      // console.log(value, "value");
      // if (value === "buyNow") {
      //   // 预下单
      //   this.$router.push("/order/purchase");
      // } else {
      //   // 加入购物车
      //   this.$toast("加入购物车成功");
      // }
    },
    stepperChange(num) {
      // 修改数量
      this.skuNum = num;
    },
    goNow(value) {
      // console.log(value);
      // 立即购买
      if (!(value.selectedSkuComb !== null)) {
        this.$toast("请选择商品规格");
        return;
      }
      // 预下单
      if (!this.checkGiftList.length && this.mallretailspu.gift) {
        this.checkGiftList.push({
          skuId: Object.values(this.mallretailspu.gift.spus[0].skus)[0].id,
          amount: 1,
          spuId: this.mallretailspu.gift.spus[0].id,
        });
      }
      const params = {
        item: {
          spuId: this.mallretailspu.id,
          skuId: value.selectedSkuComb.id,
          amount: this.skuNum,
          giftCarts: this.checkGiftList,
        },
        buyNow: "1",
        slug: this.slug,
      };
      // console.log(params);
      // return;
      // preCheckout
      this.$store
        .dispatch("cart/preCheckout", { params })
        .then(() => {
          this.showSkuSheet = false;
          this.$router.push({
            path: "/order/purchase",
            query: {
              buyNow: 1,
              spuId: this.mallretailspu.id,
              skuId: value.selectedSkuComb.id,
              amount: this.skuNum,
              giftCarts: JSON.stringify(this.checkGiftList),
            },
          });
          localStorage.removeItem("pur-note");
          localStorage.removeItem("pur-address");
          localStorage.removeItem("mall-wap-pur-choosedate");
        })
        .catch(() => {});
    },
    addCart(value) {
      if (!(value.selectedSkuComb !== null)) {
        this.$toast("请选择商品规格");
        return;
      }
      if (!this.checkGiftList.length && this.mallretailspu.gift) {
        this.checkGiftList.push({
          skuId: Object.values(this.mallretailspu.gift.spus[0].skus)[0].id,
          amount: 1,
          spuId: this.mallretailspu.gift.spus[0].id,
        });
      }
      // 加入购物车 addTCart
      const params = {
        spuId: this.mallretailspu.id,
        skuId: value.selectedSkuComb.id,
        amount: value.selectedNum,
        giftCarts: this.checkGiftList,
        slug: this.slug,
      };
      this.$store
        .dispatch("cart/addTCart", { params })
        .then(() => {
          this.showSkuSheet = false;
          this.$toast("加入购物车成功");
        })
        .catch(() => {});
    },
    closeSelectSku(value, curNum) {
      this.selectSkuString = "";
      for (const item in value.selectedSku) {
        // value.selectedSku[item] = item;
        this.selectSkuString += value.selectedSku[item];
      }
      for (let sku in value.selectedSku) {
        this.initialSku[sku] = value.selectedSku[sku];
      }
      this.initialSku.selectedNum = curNum;
    },
    sureSelectSku(value, cruNum) {
      this.skuNum = cruNum;
      this.selectSkuString = "";
      for (const item in value.selectedSku) {
        // value.selectedSku[item] = item;
        this.selectSkuString += value.selectedSku[item];
      }
    },
    // sure(value, type) {
    //   // sku确定按钮
    //   console.log(value, type, "sku确定按钮");
    // },
    // 显示海报
    clickShowPoster() {
      this.showPoster = true;
    },
    // 赠品选择
    sureGift(value) {
      this.checkGiftList = [];
      if (value.selectedSkuComb && value.selectedSkuComb.id) {
        this.checkGiftList.push({
          skuId: value.selectedSkuComb.id,
          amount: 1,
          spuId: this.giftSpuId,
          spec: value.selectedSkuComb.spec,
        });
      }
      // console.log(this.checkGiftList);
    },
    goDetail(id) {
      this.$router.push({
        path: "/product/detail",
        query: {
          id,
        },
      });
    },
    onBuyerReviewsClick() {
      this.$router.push({
        path: "/product/buyerReviews",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.5;
}
// titleBar
.bar {
  height: 48px;
  box-sizing: border-box;
  background: #fff;
  padding: 12px 12px 0;
  .go_back {
    width: 24px;
    margin-right: 36px;
  }
  .bar_title {
    display: flex;
    justify-content: center;
    a:link {
      text-decoration: none;
      color: rgba(0, 0, 0, 0.5);
    }
    a:visited {
      text-decoration: none;
    }
    a:hover {
      text-decoration: none;
    }
    a:active {
      text-decoration: none;
      font-size: 14px;
    }
    .mr_r {
      margin-right: 18px;
    }
    .title_item {
      height: 32px;
      margin-top: 3px;
      .line {
        margin-top: 8px;
        width: 24px;
        height: 4px;
        background: #000;
        border-radius: 2px;
        margin-left: 2px;
      }
    }
  }
  .share {
    width: 24px;
  }
  .mr_l {
    margin-left: 12px;
  }
}

.detail_con_out {
  padding-bottom: 136px !important;
}
.detail_con_none {
  padding-bottom: 0 !important;
}
.detail_con {
  padding-bottom: 60px;
  .swiper_list {
    width: 100%;
  }
  .title_bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }
  // 分享
  .top_share {
    z-index: 99;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    margin-top: 12px;
    img {
      width: 24px;
      margin-right: 12px;
    }
    .mr_l {
      margin-left: 12px;
    }
  }
  .other_con {
    margin: 0 10px 20px;
  }
  // spu sku选择器
  .spu_sku {
    background: #fff;
    box-shadow: 0px 3px 3px 0px rgba(193, 200, 207, 0.2);
    border-radius: 6px;
    margin-bottom: 10px;
  }
  // sku选择器
  .sku {
    margin-top: 10px;
  }
  .middle_info {
    padding: 0 10px;
    background: #fff;
  }
  .bottom_fixed {
    z-index: 99;
    position: fixed;
    bottom: -1px;
    right: 0;
    left: 0;
  }
}
.none_detail {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(191, 146, 100, 0.5);
  img {
    width: 200px;
  }
}
</style>
